import { useAuth } from "@/context/AuthContext";
import StudentDashboard from "./StudentDashboard";
import TeacherDashboard from "./TeacherDashboard";
import MentorDashboard from "./MentorDashboard";
import ParentDashboard from "./ParentDashboard";
import OwnerDashboard from "./OwnerDashboard";
import SchoolDashboard from "./SchoolDashboard";
import CorporateDashboard from "./CorporateDashboard";

export default function Dashboard() {
    const { user } = useAuth();
    if (!user) return null;
    switch (user.role) {
        case "owner":
        case "super_admin":
            return <OwnerDashboard />;
        case "teacher":
            return <TeacherDashboard />;
        case "mentor":
            return <MentorDashboard />;
        case "parent":
            return <ParentDashboard />;
        case "school_admin":
            return <SchoolDashboard />;
        case "corporate_manager":
            return <CorporateDashboard />;
        default:
            return <StudentDashboard />;
    }
}
